
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsaa2e936ac3701c2e23212b9653607d05en from './en.yaml'
            i18n.addResourceBundle('en', 'aa2e936ac3701c2e23212b9653607d05', flattenObject(nsaa2e936ac3701c2e23212b9653607d05en), true, true);
        
        export default 'aa2e936ac3701c2e23212b9653607d05';
    